export class QueryError extends Error {

}